import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { LocalStorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class AuthPasswordService {
    private httpNoInterceptors: HttpClient;

    constructor(
        httpBackend: HttpBackend,
        private cfg: ConfigService,
        private storage: LocalStorageService
    ) {
        this.httpNoInterceptors = new HttpClient(httpBackend);
    }

    async loginWithPassword(username: string, password: string): Promise<void> {
        const url = `${this.cfg.keycloakUrl}/realms/${this.cfg.keycloakRealm}/protocol/openid-connect/token`;

        const body = new URLSearchParams();
        body.set('grant_type', 'password');
        body.set('client_id', this.cfg.keycloakClientId);
        body.set('username', username);
        body.set('password', password);
        body.set('scope', 'openid');

        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

        const resp: any = await this.httpNoInterceptors
            .post(url, body.toString(), { headers })
            .toPromise();

        const access = (resp?.access_token || '').toString();
        const refresh = (resp?.refresh_token || '').toString();
        const id = (resp?.id_token || '').toString();
        if (!access || !refresh) throw new Error('No se recibieron tokens válidos del servidor');

        this.storage.setItem('KC_ACCESS_TOKEN', access);
        this.storage.setItem('KC_REFRESH_TOKEN', refresh);
        if (id) this.storage.setItem('KC_ID_TOKEN', id);
        this.storage.setItem('KC_TOKEN_ISSUED_AT', Date.now());
    }
}